module.exports = __webpack_public_path__ + "8b14410d84f4e43e7abad20d7b176e67.svg";